import type { FC } from 'react'
import type { ICmsUserGroups } from '@/pages/tad.ai/_components/FeatureCms/_types'

import LazyImage from '@/components/LazyImage'
import { H2 } from '@/pages/tad.ai/_components/H2'
import { PrimaryButton } from '@/pages/tad.ai/_components/PrimaryButton'
import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'


import { cls } from 'tagged-classnames-free';
export interface IUserGroupsProps {
  userGroups?: ICmsUserGroups | null
  className?: string
}

export const UserGroups: FC<IUserGroupsProps> = (props) => {
  const { userGroups, className } = props || {}
  if (!userGroups) {
    return null
  }
  const { title, desc, list, btnText, btnHref } = userGroups

  return (
    <div className={cls`flex flex-col items-center ${className}`}>
      <H2>{title}</H2>
      <RichTextElement
        as='p'
        html={desc}
        className='text-f-text-secondary [&_a]:!text-f-primary pt-3 text-center text-sm md:pt-6 md:text-base [&_a:hover]:underline'
      />
      <div className='grid grid-cols-1 items-center gap-4 pt-6 md:grid-cols-3 md:gap-[30px] md:pt-[128px]'>
        {list.map((item, index) => (
          <div
            key={item.label}
            className={cls`h-full rounded-3xl border border-[#65656580] p-5 md:p-6 ${index === 1 ? 'md:mt-[-160px]' : ''}`}
          >
            <span className='i-cus--tad-create text-f-primary size-6' />
            <p className='[&_a]:!text-f-primary pt-2 text-base font-bold text-white md:pt-4 md:text-2xl [&_a:hover]:underline'>
              {item.label}
            </p>
            <RichTextElement
              as='p'
              html={item.desc}
              className='text-f-text-secondary pt-2 text-sm [&_a:hover]:underline'
            />
            {item.img && (
              <LazyImage
                width={item.img.width || 332}
                height={item.img.height || 240}
                src={item.img.src}
                alt={item.label}
                className='mx-auto mt-4 overflow-hidden rounded-xl md:mt-6'
              />
            )}
          </div>
        ))}
      </div>
      {btnText && btnHref && (
        <PrimaryButton href={btnHref} className='mt-6 md:mt-12'>
          {btnText}
        </PrimaryButton>
      )}
    </div>
  )
}
